import { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import { Box, Button, IconButton, Modal, Tooltip, CircularProgress } from "@mui/material";
import Base from "../../../Base/views/Base";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteVMPreRegistrationVisitorAction,
  GetVMPreRegistrationVisitorAction,
} from "../../../../../store/Employee/Visitors/Action";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from "@mui/icons-material/Edit";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { toast } from "react-toastify";
import GetAppIcon from '@mui/icons-material/GetApp';
import ShareIcon from '@mui/icons-material/Share';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { GetEmailTokenHelper } from "../../../Ancillary/EmailToken/helper/EmailTokenHelper";
import VisitorInviteQR from "./VisitorInviteQR";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import { sendWhatsAppTextMessageHelper } from "../../../Whatsapp/helper/TemplateHelper";
import { BASE_URL } from "../../../../Constants/baseConstant";


const PreBookingRecord = ({ setMode, setCurrentEditData }) => {
  const dispatch = useDispatch();
  const { vmPreRegistrationData, vmPreRegistrationLoading } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const whatsAppFlow = atsModuleData?.find((item) => item.module_name === "Whatsapp Flow");
  const { whatsappConfigData } = useSelector((state) => state?.AncillaryReducer?.WhatsappConfigReducer);

  const [currentData, setCurrentData] = useState(null);
  const { open, fixedMenu, isMobile } = useSelector(
    (state) => state?.MenuReducer
  );
  useEffect(() => {
    dispatch(GetVMPreRegistrationVisitorAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = () => {
    dispatch(DeleteVMPreRegistrationVisitorAction({
      pre_registration_visitors_pk: currentData?.pre_registration_visitors_pk
    }));
    setCurrentData(null);
  };

  const [isQRModalOpen, setQRModalOpen] = useState(false);
  const [portalLinkData, setPortalLinkData] = useState("https://meepl.day");
  const [loadingRow, setLoadingRow] = useState(null);

  const qrRef = useRef(null);

  const handleSendWhatsappInvite = async () => {
    try {
      const configObj = whatsappConfigData?.[0] || {};
      const rawPhone = configObj?.whatsapp_business_number || "";
      let cleanPhone = String(rawPhone).replace(/[^0-9]/g, "");
      if (!cleanPhone) {
        toast.dismiss();
        toast.error("WhatsApp phone number is not configured. Please configure it under Settings > General > Configuration.");
        return;
      }

      const token = portalLinkData?.visitor_reason_comment;
      const passUrl = `${BASE_URL}/vm-guestpass-download-portal?${token}`;
      const hostName = portalLinkData?.employee_name || "-";
      const visitDate = portalLinkData?.booking_date ? ConvertDate(portalLinkData?.booking_date) : "-";
      const visitorName = portalLinkData?.visitors_name || "Guest";
      const mobileNo = portalLinkData?.visitors_mobile_no;

      if (!mobileNo) {
        toast.error("Mobile number is missing.");
        return;
      }

      const messageText = `Hi ${visitorName},\n\nYour visit has been pre-registered successfully.\n\nVisit Date: ${visitDate}\nHost: ${hostName}\n\nTo access your Check-In QR Pass, please click the link below:\n${passUrl}\n\nYou can download and show the QR pass at the entry gate during check-in.\n\npowered by Meepl`;
      sendWhatsAppTextMessageHelper({
        number: mobileNo,
        message: messageText,
        preview_url: true,
        show: true
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleGenerateLink = (data) => {
    if (data) {
      setLoadingRow(data?.pre_registration_visitors_pk);
      GetEmailTokenHelper({
        token: data?.visitor_reason_comment
      }).then((res) => {
        if (res?.data?.statuscode === 200 && res?.data?.data?.[0]?.token) {
          setPortalLinkData(data);
          setQRModalOpen(true);
        } else {
          toast.error("Guest has already checked in using this Check-In QR.");
        }
      }).finally(() => {
        setLoadingRow(null);
      });
    }
  };

  // Download QR Code as an image 
 
  const downloadQR = async () => {
  try {
    const element = qrRef.current;

    if (!element) return;

    const html2canvas = (await import("html2canvas")).default;

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const url = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = url;
    link.download = `${portalLinkData?.visitors_name}-check-in-qr.png`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error(err);
    toast.error("Failed to download invite.");
  }
};

const shareQR = async () => {
  try {
    const element = qrRef.current;

    if (!element) return;

    const html2canvas = (await import("html2canvas")).default;

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/png")
    );

    if (!blob) return;

    const file = new File(
      [blob],
      `${portalLinkData?.visitors_name}-check-in-qr.png`,
      {
        type: "image/png",
      }
    );

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        title: "Visitor Invite",
        text: "Check-In QR",
        files: [file],
      });
    } else {
      toast.error("Sharing is not supported on this device.");
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to share invite.");
  }
};

  const tableTitle = (
    <Button
      onClick={() => setMode("form")}
      variant="contained"
      className="mpl-primary-btn"
      startIcon={<AddIcon />}
      size="small"
      sx={{ textTransform: "none" }}
    >
      Pre-register
    </Button>
  )

  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 75px)", overflowY: "auto", position: "relative" }}>
        <Box
          width={
            isMobile
              ? "100%"
              : !fixedMenu && !open
                ? "calc(100vw - 75px)"
                : "calc(100vw - 255px)"
          }
        >
          <MaterialTable
            isLoading={vmPreRegistrationLoading}
            columns={[
              {
                field: "booking_date",
                title: "Visit Date",
                editable: "never",
                headerStyle: {
                  maxWidth: 125,
                  minWidth: 125,
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  maxWidth: 125,
                  minWidth: 125,
                  textAlign: "start",
                  padding: "5px 0px 5px 13px",
                },
                render: (row) => ConvertDate(row?.booking_date) || "-"
              },
              {
                field: "visitors_name",
                title: "Guest Name",
                editable: "never",
                headerStyle: {
                  maxWidth: 125,
                  minWidth: 125,
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  maxWidth: 125,
                  minWidth: 125,
                  textAlign: "start",
                  padding: "5px 0px 5px 13px",
                },
              },
              {
                field: "employee_name",
                title: "Host/Person to Meet",
                editable: "never",
                headerStyle: {
                  maxWidth: 145,
                  minWidth: 145,
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  maxWidth: 145,
                  minWidth: 145,
                  textAlign: "start",
                  padding: "5px 0px 5px 13px",
                },
              },
              {
                field: "reason",
                title: "Purpose",
                editable: "never",
                headerStyle: {
                  maxWidth: 135,
                  minWidth: 135,
                  padding: "5px 0px 5px 5px",
                  textAlign: "start",
                },
                cellStyle: {
                  maxWidth: 135,
                  minWidth: 135,
                  textAlign: "start",
                  padding: "5px 0px 5px 7px",
                },
              },
              {
                field: "visitors_mobile_no",
                title: "Guest Mobile Number",
                editable: "never",
                headerStyle: {
                  maxWidth: 130,
                  minWidth: 130,
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  maxWidth: 130,
                  minWidth: 130,
                  textAlign: "start",
                  padding: "5px 0px 5px 13px",
                },
              },
              {
                field: "qr",
                title: "Check-In QR",
                headerStyle: {
                  maxWidth: 100,
                  minWidth: 100,
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                },
                cellStyle: {
                  maxWidth: 100,
                  minWidth: 100,
                  textAlign: "start",
                  padding: "5px 0px 5px 13px",
                },
                render: (rowData) => (
                  <Tooltip title="Generate Check-In QR Code">
                    <IconButton
                      onClick={() => handleGenerateLink(rowData)}
                      disabled={loadingRow === rowData?.pre_registration_visitors_pk}
                    >
                      {loadingRow === rowData?.pre_registration_visitors_pk ? (
                        <CircularProgress size={24} />
                      ) : (
                        <QrCodeIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            data={vmPreRegistrationData}
            actions={[
              {
                icon: () => <EditIcon sx={{ color: "#637381" }} />,
                tooltip: "Edit",
                onClick: (event, rowData) => {
                  setCurrentEditData(rowData);
                  setMode("edit");
                },
              },
              {
                icon: () => <DeleteIcon sx={{ color: "#637381" }} />,
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  setCurrentData(rowData);
                },
              },
            ]}
            options={{
              maxBodyHeight: "calc(100vh - 195px)",
              minBodyHeight: "calc(100vh - 195px)",
              rowStyle: {
                fontSize: "13px",
                height: "45px",
              },
              headerStyle: {
                padding: "5px 10px 5px 13px",
                fontWeight: "bold",
              },
              sorting: true,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: false,
              showTitle: true,
              exportFileName: "Pre-registration Report",
              exportAllData: true,
              exportButton: true,
              selection: false,
            }}
            title={tableTitle}
          />
        </Box>
        <Modal
          open={isQRModalOpen}
          onClose={() => {
            setQRModalOpen(false);
            setPortalLinkData("https://meepl.day");
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "94%", sm: 540 },
              maxHeight: "92vh",
              overflow: "hidden",
              borderRadius: 3,
              outline: "none",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Top-Right Action Controls (Close, Share, Download, Send WhatsApp Invite) */}
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 20,
                zIndex: 20,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Tooltip title="Close" arrow placement="left">
                <IconButton
                  sx={{
                    background: "#fff",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                  onClick={() => setQRModalOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Share Invite QR" arrow placement="left">
                <IconButton className="mpl-primary-btn" onClick={shareQR}>
                  <ShareIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download Invite QR" arrow placement="left">
                <IconButton className="mpl-primary-btn" onClick={downloadQR}>
                  <GetAppIcon />
                </IconButton>
              </Tooltip>
              {whatsAppFlow && (
                <Tooltip title="Send WhatsApp Invite" arrow placement="left">
                  <IconButton className="mpl-primary-btn" onClick={handleSendWhatsappInvite}>
                    <WhatsAppIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>

            {/* Visitor Invite Card: center and control size on this Box */}
            <Box
              ref={qrRef}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 0,
                py: 1,
              }}
            > 
              <Box sx={{ width: { xs: "100%", sm: "85%" }, maxWidth: "440px", transform: "scale(0.75)", transformOrigin: "top center", marginBottom: "-140px", borderRadius: 2, p: 1, boxSizing: 'border-box' }}>
                <VisitorInviteQR
                  invitedBy={portalLinkData?.employee_name || ""}
                  name={portalLinkData?.visitors_name || ""}
                  purpose={portalLinkData?.reason || ""}
                  phone={portalLinkData?.visitors_mobile_no || ""}
                  locationTitle={portalLinkData?.org_name}
                  validFrom={portalLinkData?.booking_date || ""}
                  validTo={portalLinkData?.booking_date || ""}
                  qrCodeUrl={portalLinkData?.visitor_reason_comment}
                />
              </Box>
            </Box>
          </Box>
        </Modal>
        <ConfirmationDialog
          title={"Confirm Delete"}
          content={"Are you sure you want to delete this record?"}
          openDialog={Boolean(currentData)}
          closeDialog={() => setCurrentData(null)}
          OkButtonText="Yes"
          onSubmit={handleDelete}
        />
      </Box>
    </Base>
  );
};

export default PreBookingRecord;
